import React from 'react'
import { Form, Input, Button, Icon } from 'antd'

class PasswordReset extends React.Component {
    handleSubmit = e => {
        e.preventDefault()
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.props.onSubmit(values)
                this.props.form.resetFields()
            }
        })
    }

    compareToFirstPassword = (rule, value, callback) => {
        const { form } = this.props
        if (value && value !== form.getFieldValue('password')) {
            callback('Passwords do not match !')
        } else {
            callback()
        }
    }

    render() {
        const { getFieldDecorator } = this.props.form
        const { loadingAnswer } = this.props

        return (
            <Form layout="vertical" onSubmit={this.handleSubmit}>
                <input type="text" autoComplete="username" style={{ display: 'none' }} />
                <Form.Item>
                    {getFieldDecorator('old', {
                        rules: [{ required: true, message: 'Please input your Password !' }]
                    })(
                        <Input.Password
                            prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            autoComplete="current-password"
                            placeholder="old password"
                        />
                    )}
                </Form.Item>
                <Form.Item>
                    {getFieldDecorator('password', {
                        rules: [
                            { required: true, message: 'Please input your Password !' },
                            { min: 4, message: 'Password must contain at least 4 characters !' }
                        ]
                    })(
                        <Input.Password
                            prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            autoComplete="new-password"
                            placeholder="new password"
                        />
                    )}
                </Form.Item>
                <Form.Item>
                    {getFieldDecorator('confirm', {
                        rules: [
                            {
                                required: true,
                                message: 'Please confirm your password !'
                            },
                            { min: 4, message: 'Password must contain at least 4 characters !' },
                            {
                                validator: this.compareToFirstPassword
                            }
                        ]
                    })(
                        <Input.Password
                            prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            autoComplete="confirm-password"
                            placeholder="confirm password"
                        />
                    )}
                </Form.Item>
                <Form.Item>
                    <Button type="primary" htmlType="submit" className="login-form-button">
                        {loadingAnswer === true ? (
                            <Icon type="loading" style={{ fontSize: 24, padding: 4 }} spin />
                        ) : (
                            <span>Change Password</span>
                        )}
                    </Button>
                </Form.Item>
            </Form>
        )
    }
}

const FormPasswordReset = Form.create({ name: 'change_password' })(PasswordReset)

export default FormPasswordReset
